import { render, staticRenderFns } from "./PersonalFields.vue?vue&type=template&id=3a13b5a9&scoped=true"
import script from "./PersonalFields.vue?vue&type=script&lang=js"
export * from "./PersonalFields.vue?vue&type=script&lang=js"
import style0 from "./PersonalFields.vue?vue&type=style&index=0&id=3a13b5a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a13b5a9",
  null
  
)

export default component.exports